const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function digitsOnly(value: string, maxLength: number): string {
  return value.replace(/\D/g, '').slice(0, maxLength);
}

export function isValidRegistrationEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export function isValidMobilePhone(value: string): boolean {
  return /^\d{9}$/.test(value);
}

export function isValidPersonalId(value: string): boolean {
  return /^\d{11}$/.test(value);
}
